import API from './jsonapi-constants'

export const CONSTANTS = {
  TYPE: {
    LIST: 'creditLimit/list',
    ITEM: 'creditLimit/item',
  },
  ATTRIBUTE: {
    BRAND: 'brand',
    CURRENCY: 'currency',
    CREDIT_LIMIT_TOTAL: 'creditLimitTotal',
    OPEN_INVOICES: 'openInvoices',
    OPEN_DELIVERY_VALUE: 'openDeliveryValue',
    OPEN_SALES_ORDER_VALUE: 'openSalesOrderValue',
    OPEN_ITEMS_URL: 'openItemsUrl',
    DUNNING_LEVEL: 'dunningLevel',
  },
  URL_PARAM: {
    SUPPLIER: 'feSupplier',
  },
}

export const PATHS = {
  BRAND: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.BRAND],
  CURRENCY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CURRENCY],
  CREDIT_LIMIT_TOTAL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CREDIT_LIMIT_TOTAL],
  OPEN_INVOICES: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.OPEN_INVOICES],
  OPEN_DELIVERY_VALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.OPEN_DELIVERY_VALUE],
  OPEN_SALES_ORDER_VALUE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.OPEN_SALES_ORDER_VALUE],
}

export default {
  ...CONSTANTS,
  PATHS,
}
